module.exports = {
  __init__: [ 'palette' ],
  palette: [ 'type', require(144) ]
};
